import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { addJob, deleteJob, editJob, getJobById, getJobs } from './jobsAPI';

// initial state
const initialState = {
  jobs: [],
  isLoading: false,
  isError: false,
  error: '',
  singleJob: {},
  filter: '',
  search: '',
  sort: '',
};

// async thunks
export const fetchJobs = createAsyncThunk('job/fetchJobs', async () => {
  const jobs = await getJobs();
  return jobs;
});

export const fetchSingleJob = createAsyncThunk(
  'job/fetchSingleJob',
  async (id) => {
    const job = await getJobById(id);
    return job;
  }
);

export const createJob = createAsyncThunk('jobs/createJob', async (data) => {
  const job = await addJob(data);
  return job;
});

export const changeJob = createAsyncThunk(
  'job/changeJob',
  async ({ id, data }) => {
    const job = await editJob(id, data);
    return job;
  }
);

export const removeJob = createAsyncThunk('job/removeJob', async (id) => {
  const job = await deleteJob(id);
  return job;
});

// create slice
const jobSlice = createSlice({
  name: 'job',
  initialState,
  reducers: {
    filtered: (state, action) => {
      state.filter = action.payload;
    },
    searched: (state, action) => {
      state.search = action.payload;
    },
    sorted: (state, action) => {
      state.sort = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchJobs.pending, (state, action) => {
        state.isError = false;
        state.isLoading = true;
      })
      .addCase(fetchJobs.fulfilled, (state, action) => {
        state.isError = false;
        state.isLoading = false;
        state.jobs = action.payload;
      })
      .addCase(fetchJobs.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.error?.message;
        state.jobs = [];
      })
      .addCase(fetchSingleJob.pending, (state, action) => {
        state.isError = false;
        state.isLoading = true;
      })
      .addCase(fetchSingleJob.fulfilled, (state, action) => {
        state.isError = false;
        state.isLoading = false;
        state.singleJob = action.payload;
      })
      .addCase(fetchSingleJob.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.error?.message;
        state.singleJob = {};
      })
      .addCase(createJob.pending, (state, action) => {
        state.isError = false;
        state.isLoading = true;
      })
      .addCase(createJob.fulfilled, (state, action) => {
        state.isError = false;
        state.isLoading = false;
        state.jobs.push(action.payload);
      })
      .addCase(createJob.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.error?.message;
      })
      .addCase(changeJob.pending, (state, action) => {
        state.isError = false;
        state.isLoading = true;
      })
      .addCase(changeJob.fulfilled, (state, action) => {
        state.isError = false;
        state.isLoading = false;
        const indexToUpdate = state.jobs.findIndex(
          (j) => j.id === action.payload.id
        );

        state.jobs[indexToUpdate] = action.payload;
        state.singleJob = action.payload;
      })
      .addCase(changeJob.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.error?.message;
      })
      .addCase(removeJob.pending, (state, action) => {
        state.isError = false;
        state.isLoading = true;
      })
      .addCase(removeJob.fulfilled, (state, action) => {
        state.isError = false;
        state.isLoading = false;
        const indexToDelete = state.jobs.findIndex(
          (j) => j.id === action.meta.arg
        );

        state.jobs.splice(indexToDelete, 1);
      })
      .addCase(removeJob.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.error?.message;
      });
  },
});

export default jobSlice.reducer;
export const { filtered, searched, sorted } = jobSlice.actions;
